import React, { SFC } from 'react';
import classNames from 'classnames';
import { uniqueId } from 'lodash';

interface RadioButtonProps {
  id?: string;
  value?: string;
  checked?: boolean;
  small?: boolean;
  disabled?: boolean;
  onChange?: () => void;
}

export const RadioButton: SFC<RadioButtonProps> = ({
  id,
  value,
  checked,
  small,
  disabled,
  onChange,
  children,
}) => {
  const radioId = id ? id : uniqueId('radio-id-');
  const radioValue = value ? value : uniqueId('radio-value-');

  const changeHandler: React.ChangeEventHandler<HTMLInputElement> = () => {
    if (onChange) {
      onChange();
    }
  };

  return (
    <label
      className={classNames('radio-label', {
        'radio-small': small,
        'is-disabled': disabled,
      })}
      htmlFor={radioId}
    >
      <input
        type="radio"
        id={radioId}
        value={radioValue}
        checked={checked}
        disabled={disabled}
        onChange={changeHandler}
      />
      <span className="radio" />
      {children}
    </label>
  );
};
